import { isDecorationTutorialInProgress } from 'src/game/decoration/helpers';
import { getTutorialController } from 'src/game/tutorial/TutorialController';
import { createEmitter } from 'src/lib/Emitter';
import MainMenu from '../MainMenu';
import { LockableFooterButton } from './LockableFooterButton';

export class FooterMenuButton extends LockableFooterButton {
  private mainMenu: MainMenu | null = null;

  constructor() {
    super({ type: 'menu' });

    // Create tutorial hand view
    this.createTutorialHand();
  }

  public setActive(isActive: boolean) {
    super.setActive(isActive);
    if (isActive) {
      void getTutorialController().handleEvent('mainMenuOpened');
      this.mainMenu = new MainMenu();
      this.mainMenu?.once('Close', () => this.onClick());
      this.mainMenu?.fadeIn(this.getSuperview()!);
      this.tutorialHide();
    } else {
      this.mainMenu?.fadeOut();
      this.tutorialShow();
    }
  }

  /**
   * Create decoration tutorial hand it needed
   */
  private createTutorialHand() {
    // Listen for specific decoration state when we should show it
    createEmitter(
      this,
      ({ decoration }) =>
        isDecorationTutorialInProgress() &&
        decoration.tutorialDecorationScreenWasOpened === false &&
        decoration.tutorialDialogWasShown === true,
    ).addListener((show: boolean) => {
      if (show) {
        this.tutorialShow();
      } else {
        this.tutorialHide();
      }
    });
  }

  public tutorialShow() {
    // Ignore if tutorial completed
    if (!isDecorationTutorialInProgress()) return;

    super.tutorialShow();
  }
}
